<template>
  <div>
    <div class="py-2 text-center" v-if="data.length === 0">
      O participante não tem nenhuma observação
    </div>
    <template v-else>
      <template v-for="(item, index) in data">
        <!-- <v-divider v-if="index > 0" :key="'note-divider-' + index" /> -->
        <div class="py-2" :key="'note-item-' + index">
          <small>{{ item.lastUpdate | moment('DD/MM/YYYY HH:mm') }}</small>
          <br>
          <b>{{ titleObject[item.titleId] || item.titleId || 'Sem assunto' }}</b>
          <br>
          {{ item.note }}
        </div>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: 'deleteModal',
  props: {
    participantId: {
      type: String,
      default: null
    },
    celebrationId: {
      type: String,
      default: null
    },
    reference: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      loading: false,
      data: [],
      titleOptions: [],
      errorMessage: ''
    }
  },
  computed: {
    titleObject () {
      const titleObject = {}
      for (const key in this.titleOptions) {
        titleObject[this.titleOptions[key].id] = this.titleOptions[key].value
      }
      return titleObject
    }
  },
  methods: {
    getData () {
      let query = null
      this.loading = true
      this.data = []

      if (this.participantId) {
        query = this.$firestore.collection('notes').where('reference', '==', 'participant').where('participantId', '==', this.participantId)
      } else if (this.celebrationId) {
        query = this.$firestore.collection('notes').where('reference', '==', 'celebration').where('celebrationId', '==', this.celebrationId)
      }

      if (query) {
        query.get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              const item = doc.data()
              item.lastUpdate = item.lastUpdate.toDate()
              item.id = doc.id
              if (item.isActive) this.data.push(item)
            })
          })
          .catch(() => {
            this.errorMessage = 'Houve um erro ao processar as notas'
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.errorMessage = 'Houve um erro ao processar as notas'
        this.loading = false
      }
    }
  },
  mounted () {
    this.getData()
    this.$firestore.collection('titleTypes').where('reference', '==', this.reference).get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const item = doc.data()
          this.titleOptions.push(item)
        })
        this.titleOptions.sort((a, b) => a.value > b.value ? 1 : (b.value > a.value ? -1 : 0))
      })
  }
}
</script>
